import { render, staticRenderFns } from "./CashDesksNewForm.vue?vue&type=template&id=f56402e6"
import script from "./CashDesksNewForm.vue?vue&type=script&lang=js"
export * from "./CashDesksNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports